import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { UseBaseTable } from 'hooks/useBaseTable';
import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { ProgramStatusUrlParams } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramStatusSummaryReport/programStatusSummaryReportTypes';
import { UseFinishDatePredictionCompletionPlanProvider } from 'components/widgets/FinishDatePredictionCompletionPlan/FinishDatePredictionCompletionPlan.provider';
import { generateTabs } from 'components/widgets/FinishDatePredictionCompletionPlan/FinishDatePredictionCompletionPlan.utils';

interface Props {
    ui: UseFinishDatePredictionCompletionPlanProvider['ui'];
    api: UseFinishDatePredictionCompletionPlanProvider['api'];
    table: UseBaseTable['table'];
    title: string;
    subTitle: string;
}

export const useFinishDatePredictionCompletionPlanLogic = ({ table, ui, api, title, subTitle }: Props) => {
    const tabsArrData = generateTabs({ data: api.getActivityCompletionPlan.instance.data });
    const { handleSnackBar } = useCustomSnackBar();

    const hashcode = Object.values(useParams<ProgramStatusUrlParams>()).filter(Boolean).join(',');

    //  reset Pagination on sorting and new filter request
    useEffect(() => {
        table.setPagination((prev) => ({ ...prev, page: 1 }));
    }, [
        ui.state.sorting,
        ui.state.milestoneFragnet,
        ui.state.activityTypeFilter,
        ui.state.statusFilter,
        ui.state.isCriticalPath,
        ui.state.submittedCompletionFilter,
        ui.state.isDelayDriver,
    ]);

    useEffect(() => {
        if (api.getActivityCompletionPlan.instance.data) {
            table.setTotalPages(api.getActivityCompletionPlan.instance.data.numOfPages);
        }
    }, [api.getActivityCompletionPlan.instance.data]);

    const handleAPICsvExport = () => {
        api.extractCompletionPlanToCsv.instance.mutate(
            { ...api.extractCompletionPlanToCsv.payload, fileName: `${title}_${subTitle}` },
            {
                onSuccess: () => {
                    handleSnackBar('File Successfully Downloaded', 'success');
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
            },
        );
    };

    return {
        logic: {
            hashcode,
            tabsArrData,
            handleAPICsvExport,
        },
    };
};
